<template lang="html">
    <div class="sms-broadcast-statistic">
        <small class="label">
            {{ label }}
        </small>

        <ds-popover position="top">
            <template #reference>
                <span class="field">
                    {{ value }}
                </span>
            </template>

            <template #default>
                <div class="description">
                    {{ description1 }}
                    <strong>{{ description2 }}</strong>
                    {{ description3 }}
                </div>
            </template>
        </ds-popover>
    </div>
</template>

<script>
export default {
    props: {
        label: {
            type: String,
            required: true,
        },

        value: {
            type: String,
            required: true,
        },

        description1: {
            type: String,
            required: true,
        },

        description2: {
            type: String,
            required: true,
        },

        description3: {
            type: String,
            required: true,
        },
    },
};
</script>

<style lang="scss">
    div.sms-broadcast-statistic {
        display: flex;
        flex-direction: column;
        padding-right: 2rem;
        padding-bottom: 1.5rem;
    }

    div.sms-broadcast-statistic .field {
        color: $color-blue-600;
        cursor: pointer;
    }

    div.sms-broadcast-statistic .description {
        padding: 1rem;
    }

    div.sms-broadcast-statistic span.field {
        font-size: 1rem;
    }
</style>
